// src/components/ProGate.jsx
// Shows an upgrade prompt when a free user tries to access a Pro feature
import React from 'react';
import { Lock, Sparkles } from 'lucide-react';

export default function ProGate({ feature = 'This feature', children, isPro, compact = false }) {
  if (isPro) return children;

  if (compact) {
    return (
      <div style={{ display:'inline-flex', alignItems:'center', gap:5, background:'rgba(255,209,102,0.08)', border:'1px solid rgba(255,209,102,0.2)', borderRadius:6, padding:'4px 10px', cursor:'default' }}>
        <Lock size={10} style={{ color:'#ffd166' }} />
        <span style={{ fontSize:11, color:'#ffd166', fontFamily:"'DM Mono',monospace", textTransform:'uppercase', letterSpacing:'0.06em' }}>Pro</span>
      </div>
    );
  }

  return (
    <div style={{ background:'#16161f', border:'1px solid rgba(255,209,102,0.2)', borderRadius:14, padding:'36px 32px', textAlign:'center', position:'relative', overflow:'hidden' }}>
      {/* Glow */}
      <div style={{ position:'absolute', top:'50%', left:'50%', transform:'translate(-50%,-50%)', width:300, height:300, background:'radial-gradient(circle, rgba(255,209,102,0.04) 0%, transparent 70%)', pointerEvents:'none' }} />

      <div style={{ width:52, height:52, borderRadius:'50%', background:'rgba(255,209,102,0.1)', border:'1px solid rgba(255,209,102,0.2)', display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 16px' }}>
        <Lock size={22} style={{ color:'#ffd166' }} />
      </div>

      <div style={{ fontSize:16, fontWeight:600, color:'#f0f0f5', marginBottom:8, fontFamily:"'IBM Plex Sans',sans-serif" }}>
        {feature} is a Pro feature
      </div>
      <div style={{ fontSize:13, color:'#8888a8', lineHeight:1.7, marginBottom:20, maxWidth:380, margin:'0 auto 20px' }}>
        Upgrade to ODFTrades Pro to unlock deep performance diagnostics, Performance Coach reports, improvement plans, and full pattern insights.
      </div>

      <div style={{ display:'flex', flexDirection:'column', gap:8, alignItems:'center', marginBottom:20 }}>
        {[
          '7-question diagnostic report',
          'Personalised improvement plan',
          'Performance Coach report',
          'Full pattern insights',
          'Progress tracking',
        ].map((f, i) => (
          <div key={i} style={{ display:'flex', alignItems:'center', gap:8, fontSize:13, color:'#8888a8' }}>
            <span style={{ color:'#ffd166' }}>✓</span> {f}
          </div>
        ))}
      </div>

      <div style={{ display:'inline-flex', alignItems:'center', gap:6, background:'rgba(255,209,102,0.1)', border:'1px solid rgba(255,209,102,0.3)', borderRadius:9, padding:'11px 28px', fontSize:13, fontWeight:600, color:'#ffd166', fontFamily:"'IBM Plex Sans',sans-serif" }}>
        <Sparkles size={14} />
        Coming Soon — Pro Plan
      </div>

      <div style={{ fontSize:11, color:'#2a2a3e', marginTop:16, fontFamily:"'DM Mono',monospace" }}>
        Contact info@odftrades.com to get early Pro access
      </div>
    </div>
  );
}
